<template>
  <DocumentList
    document-type="draft"
    meta-name="Draft"
  />
</template>

<script>
import { mapActions } from 'pinia';
import { useAppBase } from '@/stores/app/base';
import { useFilters } from '@/stores/filters/filters';
import DocumentList from '../DocumentList.vue';

export default {
  name: 'DraftList',
  components: {
    DocumentList,
  },
  emits: ['track-page-load'],
  mounted() {
    this.showFilterBarSettings({ route: this.$route.name });
    this.$emit('track-page-load', { page: 'Library: Draft' });

    this.setFilterConfig({
      showMyJobs: true,
    });
  },
  methods: {
    ...mapActions(useAppBase, ['showFilterBarSettings']),
    ...mapActions(useFilters, ['setFilterConfig']),
  },
};
</script>
